import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          内容分类
        </h2>
        <Link
          to="/category/movie-news"
          className="flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group relative rounded-lg overflow-hidden bg-background-100 cursor-pointer h-40 md:h-48"
          >
            <img
              src={cat.coverImage}
              alt={cat.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              title={`${cat.name} - 分类封面`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-7 h-7 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className={`${cat.icon} text-white text-xs`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-white">{cat.name}</h3>
              </div>
              <p className="text-xs text-white/70 line-clamp-1 mt-1">{cat.description}</p>
              <span className="text-xs text-white/50 mt-2 inline-block">{cat.articleCount} 篇文章</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}